/** Line icons (stroke = currentColor), Pit Lane style. 24×24. */
type P = { size?: number };
const base = (size = 22) => ({
  width: size, height: size, viewBox: "0 0 24 24", fill: "none",
  stroke: "currentColor" as const, strokeWidth: 1.8, strokeLinecap: "round" as const, strokeLinejoin: "round" as const,
});

export function IconGarage({ size }: P) {
  return (
    <svg {...base(size)}>
      <path d="M4 9.5 6 4.8A2 2 0 0 1 7.8 3.6h8.4A2 2 0 0 1 18 4.8L20 9.5" />
      <path d="M3 13.2a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2V18a1 1 0 0 1-1 1h-1.5v.5a1.5 1.5 0 0 1-3 0V19H8.5v.5a1.5 1.5 0 0 1-3 0V19H4a1 1 0 0 1-1-1z" />
      <path d="M6.5 15.5h1M16.5 15.5h1" />
    </svg>
  );
}

export function IconFuel({ size }: P) {
  return (
    <svg {...base(size)}>
      <path d="M5 21V5a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v16" />
      <path d="M4 21h11" />
      <path d="M6.5 10.5h6" />
      <path d="M14 8l3 3v6.5a2 2 0 0 0 2 2 2 2 0 0 0 2-2V9.8a2 2 0 0 0-.6-1.4L18 6" />
    </svg>
  );
}

export function IconSpend({ size }: P) {
  return (
    <svg {...base(size)}>
      <rect x="3" y="6" width="18" height="13" rx="2.5" />
      <path d="M3 10h18" />
      <path d="M7 15h4" />
    </svg>
  );
}

export function IconTrips({ size }: P) {
  return (
    <svg {...base(size)}>
      <path d="M8 4.5a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 1 0 5H8" />
      <path d="M8 14.5A2.5 2.5 0 0 0 8 19.5" />
      <circle cx="8" cy="4.5" r="1" fill="currentColor" stroke="none" />
      <circle cx="16" cy="19.5" r="1" fill="currentColor" stroke="none" />
      <path d="M14 12.5h4M16 10.5v4" />
    </svg>
  );
}

export function IconSettings({ size }: P) {
  return (
    <svg {...base(size)}>
      <circle cx="12" cy="12" r="3" />
      <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
    </svg>
  );
}

export function IconTrends({ size }: P) {
  return (
    <svg {...base(size)}>
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
      <polyline points="17 6 23 6 23 12" />
    </svg>
  );
}

export function IconStation({ size }: P) {
  return (
    <svg {...base(size)}>
      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
      <circle cx="12" cy="10" r="3" />
    </svg>
  );
}

export function IconGrade({ size }: P) {
  return (
    <svg {...base(size)}>
      <path d="M4 20V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v16" />
      <path d="M4 20h14" />
      <path d="M7 11h6" />
      <path d="M7 15h4" />
      <path d="M17 7l2 2v7.5a1.5 1.5 0 0 0 3 0V9l-2-2" />
    </svg>
  );
}

export function IconSpeed({ size }: P) {
  return (
    <svg {...base(size)}>
      <path d="M12 22c5.5 0 10-4.5 10-10S17.5 2 12 2 2 6.5 2 12s4.5 10 10 10z" />
      <path d="M12 6v6l4 2" />
    </svg>
  );
}

export function IconPin({ size }: P) {
  return (
    <svg {...base(size)}>
      <path d="M12 22c0 0-7-5.5-7-10a7 7 0 0 1 14 0c0 4.5-7 10-7 10z" />
      <circle cx="12" cy="11" r="2" />
    </svg>
  );
}
